export function Item8() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Nossa equipe especializada fornece assessoria para viabilizar o
        financiamento de litígios judiciais e arbitrais. Conduzimos análises
        detalhadas dos riscos envolvidos nas disputas, adaptando nossa abordagem
        conforme a fase em que se encontra, a fim de subsidiar a tomada de
        decisão e a apresentação dos casos.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Trabalhamos em colaboração com os melhores profissionais de arbitragem,
        escritórios de advocacia e assistentes técnicos do mercado para garantir
        o sucesso de nossos clientes.
      </p>
    </>
  );
}
